export default {
    data () {
      return {
        isDestroying: false, // 用于修改轮询接口，跳转页面后的请求残留
      };
    },
    beforeDestroy () {
      // 将销毁标识位置为true,在组件销毁之前，清除定时器，排除在组件销毁之后destroyed再销毁定时器可能存在的残留或者销毁不成功问题
      this.isDestroying = true;
      if (this.statusTimeOut) {
          clearTimeout(this.statusTimeOut);
      }
    },
};



// WEBPACK FOOTER //
// ./src/mixins/isDestroying.js